<template>
	<div class="uhead f-bct">
		<div class="tit f-ct">
			<!-- <el-image class="i1" :src="require('@/static/img5.png')"></el-image> -->
			<el-image class="i2" style="cursor: pointer;" @click="link('/home')" :src="require('@/static/icon4.png')"></el-image>
			<!-- <span style="color: #38ABB0;font-size: 0.32rem;font-weight: bold;padding-left: 0.1rem;">NMКарго</span> -->
		</div>
		<div class="userBox">
			<div class="userName f-ct" style="cursor: pointer;width: 2rem;" @click="gowlink('https://t.me/seregaspb801')">
				<el-image :src="require('@/static/icon21.png')"></el-image>
				<p>Пополнить<br>Alipay</p>
			</div>
			<div class="bor"></div>
			<div class="userName f-ct" style="cursor: pointer;width: 2.5rem;" @click="gowlink('https://t.me/nmkargo/44346')">
				<el-image :src="require('@/static/icon21.png')"></el-image>
				<p>Условия<br>сотрудничества</p>
			</div>
			<div class="bor"></div>
			<div class="userName f-ct" style="cursor: pointer;width: 1.6rem;" @click="hbDel=true">
				<el-image :src="require('@/static/icon20.png')"></el-image>
				<p>Адрес<br>склада</p>
			</div>
			<div class="bor"></div>
			<div class="userName f-ct" style="width: 2.9rem;cursor: pointer;" @click="link('/daoru')">
				<el-image :src="require('@/static/icon7.png')"></el-image>
				<p>Массовый импорт<br>трек-номеров</p>
			</div>
			<div class="bor"></div>
			<div class="userName f-ct" style="width: 2.2rem;cursor: pointer;" @click="gowlink('https://t.me/nmkargo_admin')">
				<el-image :src="require('@/static/icon8.png')"></el-image>
				<p>Служба<br>поддержки</p>
			</div>
			<div class="iconBox f-ct">
				<!-- <div class="i1" @click="link('/userNews')">
					<el-image :src="require('@/static/icon3.png')"></el-image>
					<div class="new"></div>
				</div> -->
				<!-- <div class="i2">
					<el-image :src="require('@/static/icon5.png')"></el-image>
				</div> -->
				<div class="i3" @click="dialogVisible = true">
					<el-image :src="require('@/static/icon6.png')"></el-image>
				</div>
			</div>
		</div>
		<input ref="textToCopy" type="text" style="opacity: 0;position: absolute;z-index: -1;bottom: 0;" :value="textToCopy">
		<!-- Адрес -->
		<div class="maskBg" v-if="hbDel"></div>
		<div class="subTips" style="width: 402px;" v-if="hbDel">
			<el-image class="cha" @click="hbDel=false" :src="require('@/static/icon26.png')"></el-image>
			<div class="txt">Адрес склада</div>
			<div class="t1">NM****</div>
			<div class="t1">13258508080</div>
			<div class="t1">广东省佛山市南海区里水镇海南州工业区78号NMКарго(NM***)</div>
			<div class="btnBox f-ct" style="margin-top: 30px;">
				<div class="b1" @click="hbDel=false">Назад</div>
				<div class="b2" @click="copyText">Копировать</div>
			</div>
		</div>
		<!-- Превью изображения -->
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
		<!-- Выход из системы -->
		<el-dialog
				title="Подсказка"
				:visible.sync="dialogVisible"
				width="30%"
				:before-close="handleClose">
			<span>Вы действительно хотите выйти из системы?</span>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">Отмена</el-button>
		    <el-button type="danger" @click="loginOut">Подтвердить</el-button>
		  </span>
		</el-dialog>

	</div>
</template>
<script>
import { configBase } from "/src/api/api.js"
export default {
	name: "Head",
	components: {
	  'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
	},
	data(){
		return {
			hbDel:false,
			dialogVisible:false,
			imgViewerVisible:false,
			configBaseMSG:'',
			imgList:[],
			textToCopy:`
NM****
13258508080
广东省佛山市南海区里水镇海南州工业区78号NMКарго(NM***)
			`
		}
	},
	mounted() {
		this.configBase()
	},
	methods:{
		gowlink(url){
			var tempwindow=window.open('_blank');
			tempwindow.location=url;
		},
		copyText() {
		      this.$refs.textToCopy.select();
		      document.execCommand('copy');
			  this.Tips('复制成功','success')
			  this.hbDel = false
		    },
		showImgViewer(){
			this.imgViewerVisible = true;
			const m = (e) => { e.preventDefault() };
		},
		closeImgViewer(){
			this.imgViewerVisible = false;
		},
		// 基本配置
		async configBase(isIndex){
			const res = await configBase({})
			if(res.code==200){
				this.imgList = [res.data.serviceQrcode,res.data.serviceQrcode2]
			}else{this.Tips(res.msg)}
		},
		loginOut(){
			this.Tips('操作成功','success')
			this.$store.commit('userMsg/tokenC','');
			this.$store.commit('userMsg/userInfoC','');
			localStorage.clear();
			setTimeout(()=>{
				this.link('/login')
			},1500)
		},
	}
}
</script>
<style lang="scss">
body{
	background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.uhead{
	width: 1772px;
	margin: auto;
	// margin: 0 40px;
	// width: 100%;
	// width: 1574px;
	height: 102px;
	border-radius: 20px;
	// margin: auto;
	background: #fff;
	padding-left: 30px;
	padding-right: 24px;
	margin-bottom: 24px;
	margin-top: 32px;
	.tit{
		.i1{
			width: 42px;
			height: 42px;
		}
		.i2{
			// width: 166px;
			height: 102px;
			margin-left: -20px;
		}
	}
	.bor{
		width: 2px;
		height: 18px;
		background: #B9C1CB;
		margin: 0 32px;
	}
	.userBox{
		width: calc(100% - 520px);
		display: flex;
		align-items: center;
		justify-content: flex-end;
		.userName{
			flex-wrap: nowrap;
			.el-image{
				width: 24px;
				height: 24px;
				margin-right: 16px;
			}
			p{
				width: calc(100% - 30px);
				font-size: 18px;
				// text-align: j;
				// word-wrap:break-word;
				word-break:break-all;
			}
		}
	}
	.iconBox{
		// margin-left: 32px;
		.el-image{
			width: 28px;
			height: 28px;
		}
		.i1{
			margin-left: 32px;
			position: relative;
			.new{
				width: 8px;
				height: 8px;
				position: absolute;
				border-radius: 50%;
				top: 2px;
				right: 2px;
				background: #FA5555;
			}
		}
		.i2{
			margin-left: 32px;
		}
		.i3{
			margin-left: 32px;
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}


.subTips{
	position: fixed;
	width: 864px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	padding: 0 6px;
	padding-bottom: 24px;
	transform: translateX(-50%)translateY(-50%);
	.title{
		height: 69px;
		padding: 0 30px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 40px;
		.el-image{
			width: 14px;
		}
		p{
			font-size: 18px;
		}
	}
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.txt{
		font-size: 18px;
		font-weight: 600;
		color: #2F3541;
		margin-top: 35px;
		text-align: center;
		margin-bottom: 16px;
	}
	.t1{
		font-size: 16px;
		color: #7D7D89;
		// font-weight: 600;
		text-align: center;
		margin-top: 6px;
		span{
			color: #38ABB0;
			padding: 0 4px;
		}
	}
	.t2{
		font-size: 18px;
		color: #FF5F5A;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.t3{
		font-size: 14px;
		color: #999999;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.iptBox{
		width: 403px;
		margin: auto;
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.lab{
			font-size: 16px;
			color: #9A9DA7;
			width: calc(100% - 307px);
		}
		.ipt{
			width: 307px;
			border: 1px solid #E8EDF4;
			border-radius: 8px;
			padding: 0 20px;
			height: 50px;
			display: flex;
			align-items: center;
			::v-deep .el-input__inner{
				border: none;
				padding: 0 0;
				font-size: 0.16rem;
				background: none;
			}
			.selItm{
				display: flex;
				align-items: center;
				margin-right: 80px;
				.el-image{
					width: 20px;
					margin-right: 8px;
				}
				p{
					font-size: 16px;
				}
			}
		}
	}
	.btnBox{
		margin-top: 42px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #F6F6F6;
			color: #666;
		}
		.b2{
			background: #38ABB0;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>